module.exports = __webpack_public_path__ + "static/animal-er-care-2-ae423669aa42afbbdfd96babe7860d80.png";